import { Call } from '../../api/ApiCall';
import { ExcelData } from './ExcelData';

export const insertNewExcelData = async (cExcelData: ExcelData): Promise<Response> => {
  try {
    const res = await Call('excel/new', 'post', { ExcelData: cExcelData });

    if (res.ok) {
      alert('Dati caricati con successo!');
      return new Response(JSON.stringify(await res.json()), {
        status: res.status,
        headers: { 'Content-Type': 'application/json' }
      });
    } else {
      alert('Caricamento dati fallito!');
      const errorData = await res.json();
      console.error('Errore API lato server:', errorData);
      return new Response(JSON.stringify(errorData), {
        status: res.status,
        headers: { 'Content-Type': 'application/json' }
      });
    }
  } catch (error) {
    console.error('Errore di rete:', error);
    return new Response(
      JSON.stringify({ success: false, message: 'Errore di rete o server non raggiungibile' }),
      {
        status: 500,
        headers: { 'Content-Type': 'application/json' }
      }
    );
  }
};
